/**
 * Debug helpers (e.g. the 3D constraint debug) are for staging and local work. `mode` is the Vite mode of
 * the build: `staging` and `production` come from `npm run build:<environment>` (the Dockerfile passes
 * ENVIRONMENT), `development` from `npm start`. Anything else, production included, keeps them off.
 */
export const isDebugToolsEnabled = (mode: string = import.meta.env.MODE): boolean =>
  mode === "staging" || mode === "development";
